import React, { useEffect, useState } from "react";
import Constants from "../../utils/constants";
import moment from "moment";
import Chip from "@material-ui/core/Chip";

import "./styles.scss";
import { langStringConvertor } from "../../utils/utils";

const { LANGUAGES } = Constants;
const { minute, scheduleText, arrivingText, nextText, noScheduled } = LANGUAGES;

const StationEta = (props) => {
  const { stationName, time, lang, index, description, routeIds, message, etaDisplayMethod, themeColour } = props;
  const [language, setLanguage] = useState(props.language);

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  const renderTimeHeader = (time, index) => {
    const Dot = () => {
      const isNormalRoute =
        description[time.routeId][langStringConvertor(language)].match(/正常/);
      return (
        <span
          style={{
            height: "10px",
            width: "10px",
            borderRadius: "50%",
            marginLeft: "10px",
            backgroundColor: isNormalRoute ? "#59FF5E" : "#ffc9c5",
            borderStyle: "solid",
            borderWidth: "2px",
            borderColor: isNormalRoute ? "#3399FF" : "#D96466",
          }}
        />
      );
    };
    if (time) {
      if (time.vehicle) {
        if (index === 0) {
          return (
            <span className="title">
              {arrivingText[language]} <Dot />
            </span>
          );
        } else {
          return (
            <span className="title">
              {nextText[language]} <Dot />
            </span>
          );
        }
      } else {
        return (
          <span className="title">
            {scheduleText[language]} <Dot />
          </span>
        );
      }
    } else {
      return <span className="title">-</span>;
    }
  };

  const renderTime = (time, index) => {
    // console.log("time", time);
    let timeText = null;
    let shouldShowUnit = false;
    let showSmallerText = false;
    if (time && typeof time.diff === "number") {
      if (time.diff > 90) {
        shouldShowUnit = false;
        showSmallerText = true;
        // show exact time here
        timeText = moment(time.timestamp).format("HH:mm");
      } else {
        shouldShowUnit = true;
        showSmallerText = false;
        // show minute here
        timeText = Math.round(time.diff);
      }
      return (
        <>
          <span
            className="value"
            style={{
              color: `${time.vehicle ? "#3399FF" : "#AAAAAA"}`,
              fontSize: showSmallerText ? "20px" : "28px",
            }}
          >
            {timeText}
          </span>
          {shouldShowUnit && <span className="unit">{minute[language]}</span>}
          <div>
            {time[`remarks_${langStringConvertor(language)}`] && (
              <span className="remarks">{`(${
                time[`remarks_${langStringConvertor(language)}`]
              })`}</span>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          <span className="value">-</span>
          <span className="unit">{minute[language]}</span>
        </>
      );
    }
  };
  // console.log(index, time.diff, time.remarks_en);
  return (
    <div className="station-eta" key={`${stationName}`}>
      <div className="title">
        <div className="name">
          <span className={language}>{stationName}</span>
          {!!message && <span className={`message-${language}`}>{`${message}`}</span>}
        </div>
        <div className="route">
          {routeIds.map((el) => {
            // console.log(description);
            // console.log("el", el);
            const isNormalRoute =
              description[el][langStringConvertor(language)].match(/正常/);
            return (
              // <span className={language}>
              //   {description[el][langStringConvertor(language)]}
              // </span>
              <Chip
                size="small"
                style={{
                  marginLeft: "4px",
                  backgroundColor: isNormalRoute ? "#59FF5E" : "#ffc9c5",
                  borderStyle: "solid",
                  borderWidth: "2px",
                  borderColor: isNormalRoute ? "#3399FF" : "#D96466",
                }}
                label={description[el][langStringConvertor(language)]}
              />
            );
          })}
        </div>
      </div>
      {time && time.length > 0 ? (
        // {/* Eta Time  */ }
        <div className="eta">
          {index === 0 &&
          time?.find((el) => el.eta_seq === 1)?.diff === 0 &&
          !time?.find((el) => el.eta_seq === 1)?.remarks_en ? (
            <></>
          ) : (
            <div className="eta-block coming">
              {renderTimeHeader(
                time?.find((el) => el.eta_seq === 1),
                0
              )}
              <div className="time">
                {renderTime(
                  time?.find((el) => el.eta_seq === 1),
                  0,
                  themeColour
                )}
              </div>
            </div>
          )}
          <div className="eta-block later">
            {renderTimeHeader(
              time?.find((el) => el.eta_seq === 2),
              1
            )}
            <div className="time">
              {renderTime(
                time?.find((el) => el.eta_seq === 2),
                1,
                themeColour
              )}
            </div>
          </div>
          <div className="eta-block later">
            {renderTimeHeader(
              time?.find((el) => el.eta_seq === 3),
              2
            )}
            <div className="time">
              {renderTime(
                time?.find((el) => el.eta_seq === 3),
                2,
                themeColour
              )}
            </div>
          </div>
          {index === 0 &&
            time?.find((el) => el.eta_seq === 1)?.diff === 0 &&
            !time?.find((el) => el.eta_seq === 1)?.remarks_en && (
              <div className="eta-block later">
                {renderTimeHeader(
                  time?.find((el) => el.eta_seq === 3),
                  2
                )}
                <div className="time">
                  {renderTime(
                    time?.find((el) => el.eta_seq === 4),
                    3,
                    themeColour
                  )}
                </div>
              </div>
            )}
        </div>
      ) : (
        <div className="eta">
          <div className="eta-block coming">
            <div className="time"></div>
          </div>
          <div className="eta-block later">
            <div className="time"></div>
          </div>
          <div className="eta-block later">
            <div className="time">
              <span
                className="value"
                style={{
                  color: "#AAAAAA",
                  fontSize: "20px",
                }}
              >
                {noScheduled[language]}
              </span>
            </div>
          </div>
        </div>
      )}
      <hr />
    </div>
  );
};

export default StationEta;
